import { render, staticRenderFns } from "./apps-list.vue?vue&type=template&id=805367ee&scoped=true"
import script from "./apps-list.vue?vue&type=script&lang=js"
export * from "./apps-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805367ee",
  null
  
)

export default component.exports